import styled from 'styled-components';

export const ApplicationDocumentCheckWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
`;

export const ListItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  color: #555A64;

  & svg {
    color: #3CD278;
  }
`;